import { GraphQLQueryClass } from "@harea/component";
import { TDepartment, TDepartmentsResponse } from "@harea/component";
export class DepartmentListQuery
    implements GraphQLQueryClass<TDepartmentsResponse, TDResponse>
{
    public queryKey: string = "App.bo.appointment";
    public gql: string = `
        query DepartmentListQuery($data: JSONObject, $pageSize: Float, $page: Float, $sort: [TFilterSort!], $key: String) {
           departments (
                filter: { 
                    data: $data, 
                    page: $page, 
                    pageSize: $pageSize,
                    sort: $sort,
                    key: $key
                }
            ) {
                total
                data {
                    id
                    designation
                    color
                    departmentKey
                }
            }
        }
    `;
    variables?: any;
    constructor(variables?: any) {
        this.variables = variables;
    }
    mapFn(data: TDResponse): TDepartmentsResponse {
        return {
            total: data.departments.total,
            data: data.departments.data,
        };
    }
}

export type TDResponse = {
    departments:{
        total:number,
        data:Array<TDepartment>
    }
}